// extracted by mini-css-extract-plugin
export default {"withSidebar":"App_withSidebar__seTmV","withSidebarContent":"App_withSidebarContent__F+JiG","sidebarWrap":"App_sidebarWrap__jeb2z"};